export default {
  text: '#020303',
  primary: '#ae1916',
  secondary: '#94454f',
  background: '#fdfdfd',
  backgroundSecondary: 'lightgrey',
  light: '#fdfdfd',
  dark: '#020303'
}
